// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__TvjRS","text":"styles_text__NIQOc","plus18":"styles_plus18__8NP4Z","bonusImage":"styles_bonusImage__ZQ_K0"};